import { GuiTools} from './guitools.js';

export class ServerConnect extends GuiTools {
  scversion = '1.0.1';
  baseurl: string = 'http://127.0.0.1';
  port: string = ':8123';

  getversion(): Object {
    return {
      'ptversion': this.ptversion,
      'gtversion': this.gtversion,
      'scversion': this.scversion
    };
  }

  /**
   * Setup what server to load and store data from, it is usually same server as you load you application from
   * and in that case you can use location.port for the for and combine `${location.protocol}//${location.hostname}`
   * to get the correct server address 
   * @param {*} port the port used on development server or nothing if comming from default http or https ports
   * @param {*} baseurl the base url to use including protocol ex. http://127.0.0.1 for you development server
   */
  setupwhere(port: string | number, baseurl: string): void{
    if (typeof port == 'string'){
      if (port == '' || port[0]==':')
        this.port = port;
      else
        this.port = ':' + parseInt(port)
    } else {
      this.port = ':' + port;
    }
    this.baseurl = baseurl ? baseurl : this.baseurl;
  }
  /**
   * Read on record from a table on dataease server
   * @param tname Name of the table to find record in 
   * @param query The query to find the record as any DataEase queries
   * @param recno Leave blank for first match or set the record number you want starting on 0
   * @returns jdata json with result telling how it went (values ok, denied or error), if ok recorddata as requested, if error there will be a message
   * 
   * @see [Read one record - DataEase](https://server.dataease.com/viewdoc.html?&cp=DESDData&ps=DESDReadMaindata)
  */
  async recordget(tname: string, query: string, recno: undefined | number): Promise<Object>{
    recno = (recno === undefined || recno === null ? 0 : (typeof recno === 'string' ? parseInt(recno, 10) : recno));
    const url = `${this.baseurl}${this.port}/maindata/${tname}/${recno}?${query}`;
    return await this.doGet(url);
  }

  /**
   * Delete one record in a table on dataease server
   * @param tname Name of the table to find record in 
   * @param query he query to find the record as any DataEase queries
   * @param recno Leave blank for first match or set the record number you want starting on 0
   * @returns jdata json with result telling how it went (values ok, denied or error), if ok it returns recno that was deleted
   * 
   * @see [Delete one record - DataEase](https://server.dataease.com/viewdoc.html?&cp=DESDData&ps=DESDDeleteOneRecord)
  */
  async recorddelete(tname: string, query: string, recno: undefined | number): Promise<Object>{
    recno = (recno === undefined || recno === null ? 0 : (typeof recno === 'string' ? parseInt(recno, 10) : recno));
    const url = `${this.baseurl}${this.port}/maindata/${tname}/${recno}?${query}`;
    return await this.doDelete(url);
  }

  /**
   * Run a execdql as high user or a server dql with security as set in document 
   * @param name dql/body to run, name can be @name, #number and *: for execdqls or plain names for server dqls. You can name a dql and body by dqlname/bodyname
   * @param dataentry object with dataentry that can be used for dql, server dql can have any name, execdql only field1-4
   * @returns jdata with result, if execdql with body the body can be found in jdata.data if jdata.result == 'ok'
   * 
   * @see [run dql - DataEase](https://server.dataease.com/viewdoc.html?&cp=DESDData&ps=DESDData)
   */
  async rundql(name: string, dataentry: undefined | Object): Promise<Object|string>{
    let url;
    if (name.length>0){
      let ending = '';
      if (name[name.length-1] != '/') ending +='/';
      if (name[0]=='/') // a page returned as json
        url = `${this.baseurl}${this.port}/run/dql${name}${ending}?`;
      else
        url = `${this.baseurl}${this.port}/run/dql/${name}${ending}?`;
    }
		if (dataentry){
			for (let key in dataentry){
				var val = dataentry[key];
				url += "&" + key + "=" + val;
			}
		}
    return await this.doGet(url);
  }

  /**
   * Update an exsiting record in a table
   * @param tname Name of the table to find record in 
   * @param query The query to find the record as any DataEase queries
   * @param rec a object containing the data you want to change in a record
   * @param recno Leave blank for first match or set the record number you want starting on 0
   * @returns jdata json with result telling how it went (values ok, denied or error), if ok a recorddata with changed vales are returned, if error there will be a message
   * 
   * @see [Write one record - DataEase](https://server.dataease.com/viewdoc.html?&cp=DESDData&ps=DESDWriteOneRecord)
  */
  async recordupdate(tname: string, query: string, rec: Object, recno: undefined | number): Promise<Object>{
    recno = (recno === undefined || recno === null ? 0 : (typeof recno === 'string' ? parseInt(recno, 10) : recno));
    const url = `${this.baseurl}${this.port}/maindata/${tname}/${recno}?${query}`;
    return await this.doPut(url, {'recorddata' : rec});
  }

  /**
   * Create a new record
   * @param tname Name of the table to find record in 
   * @param rec a object containing all data needed to create a record
   * @returns jdata json with result telling how it went (values ok, denied or error), if ok a recorddata with changed vales are returned, if error there will be a message
   * 
   * @see [Write one record - DataEase](https://server.dataease.com/viewdoc.html?&cp=DESDData&ps=DESDWriteOneRecord)
  */
  async recordnew(tname: string, rec: Object): Promise<Object>{
    const url = `${this.baseurl}${this.port}/maindata/${tname}/`;
    return await this.doPost(url, {'recorddata' : rec});
  }
}